module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/mapaDopravnichProudu@2x-6040e18c0fdb4706413c3b032b3de4d8.png";